import Modal from 'antd/lib/modal';
import { Row, Col } from 'antd';
import { Formik } from 'formik';
import { Form } from 'formik-antd';
import { MdOutlineColorLens } from 'react-icons/md';
import IntlMessages from '../../../../../../../domain/utility/IntlMessages';
import Button from '../../../../../../../shared/components/button';
import { BsCheckLg } from 'react-icons/bs';
import { useIntl } from 'react-intl';
import LanguagesTab from '../../../../../../../shared/components/languages-tab';
import LanguageCode from '../../../../../../../shared/services/types/language-code';
import EditManageSubColorLanguage from './edit-manage-sub-color-language';
import { useEffect, useState } from 'react';
import { PredefinedColorValueSubColorListDto } from '../../../../../../../shared/services/product-attribute/dto/predefined-color-value-sub-color-list-dto';
import { CreateValueSubColorDto } from '../../../../../../../shared/services/product-attribute/dto/create-value-sub-color-dto';
import { productAttributesService } from '../../../../../../../shared/services/product-attribute';
import { useParams } from 'react-router-dom';
import MainUtils from 'src/shared/utils/main';
import { useLocaleContext } from 'src/domain/utility/AppContextProvider/LocaleContextProvide';
import { getLocaleValue } from 'src/shared/functions/change-locales';
import { stockAdjustmentSchema } from './schema';

interface IEditManageSubColorModalProps {
  visible: boolean;
  subColorDetails?: PredefinedColorValueSubColorListDto;
  onCancel: () => void;
  onFinish: () => void;
}

const EditManageSubColorModal = (props: IEditManageSubColorModalProps) => {
  const { visible, subColorDetails, onCancel, onFinish } = props;

  const { messages } = useIntl();

  const { id } = useParams();

  const [initialValuesForm, setInitialValuesForm] =
    useState<CreateValueSubColorDto>({
      name: '',
    });

  const { locale }: any = useLocaleContext();

  useEffect(() => {
    if (subColorDetails && visible) {
      setInitialValuesForm({
        name: subColorDetails?.Name,
        id: subColorDetails?.Id,
        locales:
          subColorDetails?.Locales?.map((item) => {
            return {
              id: item.Id,
              languageId: item.LanguageId,
              localeKey: item.LocaleKey,
              localeValue: item.LocaleValue,
            };
          }) ?? [],
      });
    } else
      setInitialValuesForm({
        name: '',
        locales: [],
      });
  }, [subColorDetails, visible]);

  const handleSubmit = async (values: any, setSubmitting: any) => {
    try {
      if (subColorDetails) {
        await productAttributesService.editValueSubColor({
          ...values,
          name: !MainUtils.isEmptyValue(
            getLocaleValue(values?.locales, LanguageCode.English, 'name'),
          )
            ? getLocaleValue(values?.locales, LanguageCode.English, 'name')
            : getLocaleValue(values?.locales, LanguageCode.Arabic, 'name'),
          mainColorId: id ?? '',
        });
      }
      await onFinish();
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const langComponent = [
    {
      code: LanguageCode.English,
      langComponent: (
        <EditManageSubColorLanguage code={LanguageCode.English} index={0} />
      ),
    },
    {
      code: LanguageCode.Español,
      langComponent: (
        <EditManageSubColorLanguage code={LanguageCode.Español} index={1} />
      ),
    },
    {
      code: LanguageCode.Arabic,
      langComponent: (
        <EditManageSubColorLanguage code={LanguageCode.Arabic} index={2} />
      ),
    },
  ];

  return (
    <Formik
      enableReinitialize
      initialValues={initialValuesForm}
      onSubmit={(values, { setSubmitting }: any) =>
        handleSubmit(values, setSubmitting)
      }
      validationSchema={stockAdjustmentSchema(messages)}
      validateOnChange={false}
      validateOnBlur={false}>
      {({ handleSubmit, isSubmitting }: any) => (
        <Form>
          <Modal
            className='add-option-modal'
            width={'700px'}
            open={visible}
            maskClosable={false}
            title={
              <>
                <div className='text-title'>
                  <span className='icon-title'>
                    <MdOutlineColorLens />
                  </span>
                  <IntlMessages id='productAttributes.productAttributesPredefinedValues.mangeSubColor.editTitle' />
                </div>
              </>
            }
            onCancel={onCancel}
            footer={false}>
            <Row gutter={[0, 20]}>
              <Col span={24}>
                <Row justify='end'>
                  <Col>
                    <Button
                      icon={<BsCheckLg className='add-button-icon' />}
                      onClickAction={handleSubmit}
                      text={messages['common.save'].toString()}
                      type='primary'
                      size='small'
                      className='add-button'
                      loading={isSubmitting}
                    />
                  </Col>
                </Row>
              </Col>

              <Col span={24}>
                <div className='languages-tab'>
                  <LanguagesTab
                    languagesList={langComponent}
                    tabItem={{
                      key: 'Standard',
                      label: `${messages[
                        'category.categoryInfo.Standard'
                      ].toString()}`,
                      children: (
                        <EditManageSubColorLanguage
                          code={`${!MainUtils.isEmptyValue(locale.code)
                            ? locale.code
                            : LanguageCode.English
                            }`}
                        />
                      ),
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};

export default EditManageSubColorModal;
